export default __webpack_public_path__ + "static/media/google.43f3f828.svg";